<script>
import BookingStatusLabelType from '@/shared/constants/booking/BookingStatusLabelType'
import BookingStatusLabel from '@components/booking/booking-status-label.vue'
import DayByDayEducator from '@/components/booking/bookingList/day-by-day-educator.vue'
import SentToEducator from '@/components/booking/bookingList/sent-to-educator.vue'
import NoEducator from '@/components/booking/bookingList/no-educator.vue'

export default {
  name: 'BookingDaysTable',
  components: {
    BookingStatusLabel,
    DayByDayEducator,
    SentToEducator,
    NoEducator,
  },
  props: {
    blocks: { type: Array, required: true, default: () => [] },
    display: { type: Function, required: true },
  },
  data() {
    return {
      BookingStatusLabelType,
    }
  },
  computed: {
    daysComputed() {
      if (!this.blocks.length) return []
      return this.blocks.map((b) => {
        const c = b.candidate
        const first = (c?.firstName || '').trim()
        const last = (c?.lastName || '').trim()
        const hasAny = !!(first || last)
        const name = hasAny
          ? `${first}${first && last ? ' ' : ''}${last}`
          : this.display(null)
        return {
          date: this._formatDayForTable(b.start),
          time: this._formatTimeRangeForTable(b.start, b.end),
          name,
          status: this.display(b.status),
          candidate: b.candidate,
        }
      })
    },
  },
  methods: {
    // Time range
    _formatTimeRangeForTable(start, end) {
      if (!start || !end) return '-'
      const sh = start.getHours()
      const sMin = String(start.getMinutes()).padStart(2, '0')
      const startStr = `${sh}:${sMin}`

      const eh = String(end.getHours()).padStart(2, '0')
      const eMin = String(end.getMinutes()).padStart(2, '0')
      const endStr = `${eh}:${eMin}`

      return `${startStr} – ${endStr}`
    },
    // Days
    _formatDayForTable(d) {
      if (!d) return '-'
      const wd = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(
        d
      )
      const day = new Intl.DateTimeFormat(undefined, { day: 'numeric' }).format(
        d
      )
      const mon = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(d)
      const yr = new Intl.DateTimeFormat(undefined, { year: 'numeric' }).format(
        d
      )
      return `${wd}, ${day} ${mon} ${yr}`
    },
  },
}
</script>

<template>
  <!-- DAYS TAB -->
  <v-tab-item>
    <v-simple-table class="days-table">
      <thead>
        <tr>
          <th class="th">{{ $t('sidePanel.details') }}</th>
          <th class="th">{{ $t('sidePanel.time') }}</th>
          <th class="th">{{ $t('sidePanel.educator') }}</th>
          <th class="th text-center">{{ $t('sidePanel.status') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(d, i) in daysComputed" :key="`days-tr-${i}`">
          <td class="td">{{ d.date }}</td>
          <td class="td">{{ d.time }}</td>
          <td class="td td-educator">
            <SentToEducator
              v-if="d.status === BookingStatusLabelType.Pending"
            />

            <NoEducator v-else-if="d.status === BookingStatusLabelType.Open" />

            <template v-else>
              <DayByDayEducator :candidate="d.candidate" />
            </template>
          </td>
          <td class="td">
            <BookingStatusLabel
              :class="['status-chip status-label', d.status.toLowerCase()]"
              :status="d.status"
            />
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-tab-item>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/side-panel.scss';
</style>
